module.exports = __webpack_public_path__ + "static/img/people.83ef79fd.svg";